<template>
    <div class="editor" id="editor"
        :class="{ edit: isEdit }">
        <!-- 右击菜单 -->
        <ContextMenu />
        <!--地图-->
        <Map/>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import ContextMenu from './ContextMenu'

import Map from './Map.vue'

export default {
    props: {
        isEdit: {
            type: Boolean,
            default: true,
        },
    },
    components: { ContextMenu, Map},
    data() {
        return {
            editorX: 0,
            editorY: 0,
            start: { // 选中区域的起点
                x: 0,
                y: 0,
            },
            width: 0,
            height: 0,
            isShowArea: false,
        }
    },
    computed: mapState('simulation',[
        'componentData',
        'editor',
        'map',
        'curFeatures', // 当前选中内容
    ]),
    mounted() {
        this.$bus.$on('hideArea', () => {
            this.hideArea()
        })
    },
    methods: {
        hideArea() {
            this.isShowArea = 0
            this.width = 0
            this.height = 0
        },
    },
}
</script>

<style lang="scss" scoped>
.editor {
    position: relative;
    background: #fff;
    margin: auto;
    height: 100%;
    width: 100%;
}
</style>
